import { Component, OnInit, Inject } from "@angular/core";
import { Store } from "@ngrx/store";
import * as actions from "../../../store/actions/index";
import * as selectors from "../../../store/reducers/index";
import { Observable } from "rxjs";
import { MemberResponseInterface } from "@careapp/angular-sdk";
import {
  CUSTOMER_CARER_ROLE,
  CARER_ROLE,
  CUSTOMER_FAMILY_ROLE,
  FAMILY_ROLE
} from "@careapp/core";
import { AddTeamData } from "./add-to-team-form.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "add-to-team-dialog",
  templateUrl: "./add-to-team-dialog.component.html"
})
export class AddToTeamDialog implements OnInit {
  constructor(
    private store: Store<any>,
    private dialogRef: MatDialogRef<AddToTeamDialog>,
    @Inject(MAT_DIALOG_DATA) private customerId: any
  ) {}

  staff$: Observable<MemberResponseInterface[]>;
  ngOnInit() {
    this.staff$ = this.store.select(
      selectors.getSearchResults(selectors.STAFF)
    );
    this.store.dispatch(actions.Staff.RequestAllAction);
    this.searchStaff("");
  }

  addToTeam(data: AddTeamData) {
    console.log(data);
    if (data.member) {
      this.addMember(data);
    } else {
      this.invite(data);
    }
    this.dialogRef.close();
  }

  searchStaff(search) {
    let or = [];

    if (!search.trim()) {
      return;
    }

    search
      .split(" ")
      .filter(term => !!term || !!term.trim())
      .forEach(term => {
        or = or.concat(
          ["firstName", "lastName", "email"].map(key => ({
            [key]: { ilike: `${term.trim()}%` }
          }))
        );
      });

    this.store.dispatch(actions.Staff.RequestSearchAction({ where: { or } }));
  }

  cancelPressed() {
    this.dialogRef.close();
  }

  addMember(data: AddTeamData) {
    this.store.dispatch(
      actions.CustomerTeam.RequestCreateAction(<any>{
        staff: data.member,
        role: data.role
      })
    );
  }

  invite(data: AddTeamData) {
    const permissions = [
      {
        modelId: this.customerId,
        modelName: "Customer",
        role: data.role
      }
    ];
    let role;
    switch (data.role) {
      case CUSTOMER_CARER_ROLE:
        role = CARER_ROLE;
        break;
      case CUSTOMER_FAMILY_ROLE:
        role = FAMILY_ROLE;
        break;
      default:
        return;
    }
    this.store.dispatch(
      new actions.RequestInvitationSendAction({
        email: data.email,
        role,
        permissions
      })
    );
  }
}
